import { render, staticRenderFns } from "./onlineDatadv.vue?vue&type=template&id=118cecac&scoped=true&"
import script from "./onlineDatadv.vue?vue&type=script&lang=js&"
export * from "./onlineDatadv.vue?vue&type=script&lang=js&"
import style0 from "./onlineDatadv.vue?vue&type=style&index=0&id=118cecac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118cecac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('118cecac')) {
      api.createRecord('118cecac', component.options)
    } else {
      api.reload('118cecac', component.options)
    }
    module.hot.accept("./onlineDatadv.vue?vue&type=template&id=118cecac&scoped=true&", function () {
      api.rerender('118cecac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/onlineDatadv.vue"
export default component.exports